import React, { useEffect, useState, useRef } from "react";
import { Container, Col, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import { useLazyQuery, useSubscription } from "@apollo/client";
import { Grid, Paper, Button } from "@material-ui/core";

import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { GlobalMasterSearch } from "../../../Components/GlobalMasterSearch";
import { SectionLoader } from "../../../Components/SectionLoader";
import { NOTIFICATION_SUBSCRIPTION } from "../../../GraphQlCommon/mutation";
import { base64Encode, page360Url } from "../../../Utils/helper";
import * as actions from "../../Dashboard/_redux/dashboardActions";

import {
  LIST_CATEGORIES_BY_PRIORITY,
  LIST_FEATURED_ASSET,
} from "./graphql/query";

export const CategoryList = React.memo(({ history }) => {
  // for dispatch action while use redux
  const dispatch = useDispatch();

  const [user, setUser] = useState();

  const [
    getCategories,
    { loading: categoriesLoading, error: categoriesError, data: categoriesData },
  ] = useLazyQuery(LIST_CATEGORIES_BY_PRIORITY, {
    fetchPolicy: "no-cache",
  });

  const [
    getFeaturedAssets,
    {
      loading: getFeaturedAssetsLoading,
      error: getFeaturedAssetsError,
      data: getFeaturedAssetsData,
    },
  ] = useLazyQuery(LIST_FEATURED_ASSET, {
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    let user = JSON.parse(window.localStorage.getItem("user"));

    if (user) {
      setUser(user);
    }
  }, [window.localStorage.getItem("user")]);

  useEffect(() => {
    getCategories();
    getFeaturedAssets();
    window.scrollTo(0, 0);
  }, [getCategories, getFeaturedAssets]);

  useEffect(() => {
    dispatch(actions.loading(categoriesLoading));
    if (categoriesData) {
      dispatch(actions.list(categoriesData.listCategoriesByPriority));
    }
  }, [categoriesLoading, categoriesError, categoriesData, dispatch]);

  useEffect(() => {
    dispatch(actions.loading(getFeaturedAssetsLoading));
    if (getFeaturedAssetsData) {
      dispatch(
        actions.featuredAssetList(
          getFeaturedAssetsData.getFeatureListingOfAsset,
        ),
      );
    }
  }, [getFeaturedAssetsLoading, getFeaturedAssetsError, getFeaturedAssetsData]);

  useSubscription(NOTIFICATION_SUBSCRIPTION, {
    variables: {
      recievedId: user && user.id,
    },
    fetchPolicy: "no-cache",
    onSubscriptionData(d) {
      toast.success(
        formatText(
          d.subscriptionData.data.sendNotificationForBid.message.toString(),
        ),
        {
          position: toast.POSITION.TOP_RIGHT,
        },
      );
    },
  });
  const formatText = text => {
    return (
      <div
        dangerouslySetInnerHTML={{
          __html: text,
        }}
      />
    );
  };

  const onHandleClick = item => {
    history.push({
      pathname: `/search-asset/${item.name}/${base64Encode(item.id)}`,
      state: { name: item.name, ids: base64Encode(item.id) },
    });
  };

  const callAssetDetailPage = item => {
    history.push({
      pathname: page360Url(item),
      state: { name: "detail", item: item },
    });
  };

  // Getting curret state of dashboard category list from store (Redux)
  const { entities } = useSelector(
    state => ({ entities: state.dashboard.entities }),
    shallowEqual,
  );

  const { listLoading } = useSelector(
    state => ({ listLoading: state.dashboard.listLoading }),
    shallowEqual,
  );

  const { featuredAssetList } = useSelector(
    state => ({ featuredAssetList: state.dashboard.featuredAssetList }),
    shallowEqual,
  );

  function FormRow() {
    const elements = entities.map((item, index) => {
      return (
        <Grid item xs={12} md={3} sm={6} key={`container-${item.id}`}>
          <Paper
            square
            elevation={0}
            key={`paper-${item.id}`}
            variant="elevation"
            onClick={() => onHandleClick(item)}
          >
            <img
              width="44"
              src={toAbsoluteUrl("/media/truck-icon.svg")}
              alt="image"
            />

            <h5>{item.name}</h5>
          </Paper>
        </Grid>
      );
    });

    return entities.length > 0 ? (
      elements
    ) : (
      <h6 className="noCategList">
        {" "}
        <FormattedMessage id="CATEGORY.NO_LIST" />
      </h6>
    );
  }

  const featuredAssetImg = item => {
    if (item.assetMedias) {
      const tempObj = item.assetMedias.find(asset => asset.isPrimary === true);

      if (tempObj) {
        return <img width="44" src={tempObj.media} alt={tempObj.media} />;
      }
    }
  };

  function FeturedAssetRow() {
    const elements = featuredAssetList.map((item, index) => {
      return (
        <Grid item xs={12} md={3} sm={6} key={`container-${item.id}`}>
          <Paper
            square
            elevation={0}
            key={`paper-${item.id}`}
            variant="elevation"
            onClick={() => callAssetDetailPage(item)}
          >
            {featuredAssetImg(item)}
            <h5>
              {item.make?.name} {item.model?.name}
            </h5>
          </Paper>
        </Grid>
      );
    });

    return featuredAssetList.length > 0 ? (
      elements
    ) : (
      <h6 className="noCategList">
        {" "}
        <FormattedMessage id="FEATURED_ASSET.NO_LIST" />
      </h6>
    );
  }

  const inputRef = useRef();

  const equipmentSearch = () => {
    const val = inputRef.current.value;

    if (val) {
      history.push(`/search?q=${val}`);
    }
  };

  return (
    <>
      <SectionLoader loader={listLoading} />
      <Container>
        <Row className="logoRow">
          <Col className="d-flex justify-content-center ">
            <img src={toAbsoluteUrl("/media/logos/equipnow.png")} alt="image" />
          </Col>
        </Row>

        <Row className="filterBtnRow mt-15">
          <Col className="d-flex justify-content-center ">
            <GlobalMasterSearch
              history={history}
              // inputRef={inputRef}
              // search={equipmentSearch}
            />
          </Col>
        </Row>

        <Row className="btnRow">
          <Col className="d-flex justify-content-center ">
            <Button
              className="btn-orange"
              color="primary"
              onClick={equipmentSearch}
            >
              <FormattedMessage id="EQUIPMENT.SEARCH" />
            </Button>
          </Col>
        </Row>
      </Container>

      <Container>
        <Row className="justify-content-center">
          <Col lg="12" xl="8">
            <h3 className="heading-style-03 mb-md-3 mb-lg-10 mt-5 mt-md-0">
              {" "}
              <FormattedMessage id="CATEGORY.LIST" />
            </h3>
            <div className="dashboardCategList">
              <Grid
                key="all-container-category"
                container
                item
                xs={12}
                spacing={5}
              >
                <FormRow key="all-category-list" />
              </Grid>
            </div>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col lg="12" xl="8">
            <h3 className="heading-style-03 mb-md-3 mb-lg-10 mt-5 mt-md-0">
              {" "}
              <FormattedMessage id="FEATURED_ASSET.LIST" />
            </h3>
            <div className="dashboardCategList">
              <Grid
                key="all-container-category"
                container
                item
                xs={12}
                spacing={5}
              >
                <FeturedAssetRow key="all-category-list" />
              </Grid>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
});
